jQuery(document).ready(function ($) {

    // If an event gets to the body
    $(".popup").click(function () {
        $(".popup").removeClass('show');
        $(window).off('scroll');
    });

    // Prevent events from getting pass .popup
    $(".popup__window").on('click', function (e) {
        e.stopPropagation();
    });

    $('.close').on('click', function () {
        $(window).off('scroll');
        $('.popup').removeClass('show');
    });

});
